function showLoader() {
    document.querySelector('#preloader').classList.add('active');
}

export default showLoader;